import { css } from '@emotion/core';
import padding from "../../Styles/padding";
import colors from "../../Styles/colors";
import {PlayButton, Rv3triangle} from "../../Homepage/components/PlayButton";
import React from "react";
import {fontSize, fontWeight} from "../../Styles/text";
import {getHumanAirtime} from "../../ScheduleV2/components/grid/Expansion";

const DEFAULT_THUMBNAIL = '<img src="/content/themes/tpt/dist/images/default-post-image.jpg" alt="Default image">';

let preview = css`
  position: relative;
  width: 100%;
  margin: 0 ${padding.standard};
  cursor: pointer;
  
  @media(min-width: 500px) {
    width: auto;
    flex-basis: calc(50% - 16px);
  }
  
  @media(min-width: 720px) {
    width: auto;
    flex-basis: calc(33% - 16px);
  }
  
  &:hover {
    ${Rv3triangle} {
      fill: ${colors.accent};
    }
  }
`;

let button = css`
  padding: 4px 0;
  text-align: center;
  ${fontSize(4)};
  border: 1px solid ${colors.coreColor1};
  border-bottom: 0;
  font-weight: bold;
`;

let activeColors = css`
  background: ${colors.main};
  color: ${colors.coreColor2};
`;

let thumbnailWrapper = css`
  position: relative;
  padding-bottom: 56.25%;
  border: 1px solid ${colors.coreColor1};
`;

let thumbnailImage = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  
  & > img {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

let live = css`
  position: absolute;
  top: 0;
  right: 0;
  color: ${colors.coreColor2};
  line-height: 1.25;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  padding: 2px 4px;
  background: ${colors.accent};
`

let showTitle = css`
  margin: ${padding.standard} 0;
  font-weight: 800;
  font-size: 1.375rem;
  line-height: 1.25;
  text-transform: uppercase;
`;

let episodeTitle = css`
  margin: ${padding.standard} 0;
  line-height: 1.25;
`;

let play = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

let airtime = css`
  font-size: 0.75rem;
  font-weight: ${fontWeight.bold};
`;

export default function Preview({ channel, active, show, episode, airing, thumbnail, onClick, additionalAirings }) {
  return <div css={preview} onClick={onClick}>
    <div css={active ? [button, activeColors] : button}>
      { channel }
    </div>
    <div css={thumbnailWrapper}>
      <div css={thumbnailImage} dangerouslySetInnerHTML={{ __html: thumbnail || DEFAULT_THUMBNAIL }} />
      <div css={play}>
        <PlayButton/>
      </div>
      <div css={live}>Live</div>
    </div>
    <div css={showTitle}>{ show }</div>
    <p css={episodeTitle}>{ episode }</p>
    {
      show &&
      airing && <p css={airtime}>{getHumanAirtime(airing)}</p>
    }
  </div>;
}